import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Padding } from '@mui/icons-material';

export const BookingContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: 'calc(100dvh - 132px)', // 132px = 60px (footer) + 72px (header)
  background: 'none',
  padding: 0,
  transition: 'all 0.3s ease-in-out',
}));

export const BreadcrumbsBar = styled(Paper)(({ theme }) => ({
  borderRadius: 24,
  padding: `10px 0`,
  marginBottom: theme.spacing(0),
  marginLeft: 'auto',
  marginRight: 'auto',
  display: 'flex',
  alignItems: 'center',
  background: 'none',
  boxShadow: 'none',

  [theme.breakpoints.down('md')]: {
    padding: `${theme.spacing(2)} ${theme.spacing(0)}`,
  },

  p: {
    fontSize: 12,
  },
}));

export const MainCard = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  background: 'none',
  padding: theme.spacing(0, 2, 3, 2),
}));

export const GalleryImageWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: 600,
  [theme.breakpoints.down('md')]: {
    height: 600,
  },
  [theme.breakpoints.down('sm')]: {
    height: 400,
  },
}));

export const GalleryImage = styled('img')(({ theme }) => ({
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  borderRadius: 24,
  maxWidth: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 1,
  transition: 'opacity 0.4s',
  '&.gallery-fade-out': {
    opacity: 0,
    zIndex: 1,
  },
  '&.gallery-fade-in': {
    opacity: 1,
    zIndex: 2,
  },
}));

export const GalleryThumb = styled('img')(({ theme }) => ({
  width: 64,
  height: 48,
  objectFit: 'cover',
  borderRadius: 8,
  border: `2px solid transparent`,
  cursor: 'pointer',
  marginRight: 8,
  transition: 'border 0.2s',
  boxShadow: 'none',
  '&.active': {
    border: `2px solid ${theme.palette.primary.main}`,
    boxShadow: theme.shadows[2],
  },
}));

export const InfoSection = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(0, 0, 0, 0),

  figure: {
    margin: '0',

    img: {
      width: '-webkit-fill-available;',
      objectFit: 'contain',
      borderRadius: '8px',
      boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.1)',
    },
  },
}));
